export default __webpack_public_path__ + "static/media/updateWhisesCandidate.909b4679.svg";